function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#d82126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.679c-.091,0-.177-.018-.266-.027l-1.234,4.848h3l-1.234-4.848c-.089.009-.175.027-.266.027Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.321c.091,0,.177.018.266.027l1.234-4.848h-3l1.234,4.848c.089-.009.175-.027.266-.027Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.882,13.376L4.5,7.5H0l12.568,6.39c.084-.185.192-.354.314-.514Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.321,15c0-.091.018-.177.027-.265L0,13.5v3l12.348-1.235c-.009-.089-.027-.174-.027-.265Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.568,16.11L0,22.5h4.5l8.382-5.876c-.122-.159-.23-.329-.314-.514Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.432,16.11c-.084.185-.192.354-.314.514l8.382,5.876h4.5l-12.568-6.39Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.432,13.89l12.568-6.39h-4.5l-8.382,5.876c.122.159.23.329.314.514Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.679,15c0,.091-.018.177-.027.265l12.348,1.235v-3l-12.348,1.235c.009.089.027.174.027.265Z",
    style: {
      fill: "#f8e92e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2.143,
    style: {
      fill: "#f8e92e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.d7ce045c717bf4b35df8051bae272f3b.svg";
export { ForwardRef as ReactComponent };